var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!!_vm.banners)?_c('swipe-active',{attrs:{"module-title":_vm.moduleTitle,"list":_vm.banners}}):_vm._e(),_vm._v(" "),(!!_vm.middleBanners)?_c('swipe-active',{attrs:{"module-title":_vm.timeModuleTitle,"list":_vm.middleBanners}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-49853f97","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/views/CardItems.vue
// module id = null
// module chunks = 